<div class="container">

  <app-header-dialog [iconName]="'post_add'">
    Documentos
  </app-header-dialog>

  <form class="form" name="entityForm" [formGroup]='entityForm' autocomplete="off">

    <div class='tab-content'>

      <div style="margin-bottom: 10px;" *ngIf="!isEdit">

        <input #file type="file" style='display:none;' (change)="previewDoc($event)" />

        <button mat-raised-button (click)='file.click()'>
          <mat-icon class='icon-add'>image_search</mat-icon>
        </button>
      </div>

      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Arquivo</mat-label>
        <input readonly matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.filename"
          autocomplete="off">
        <mat-error *ngIf="entityForm.controls.filename.hasError('required')">
          O nome do arquivo é obrigatório
        </mat-error>
      </mat-form-field>


      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Pasta</mat-label>
        <mat-select (ngModelChange)='selectFolder($event)' [formControl]="entityForm.controls.folder_id"
          style="padding: 5px 0 5px 5px;">
          <mat-option *ngFor="let folder of folders" [value]="folder.id">
            {{ folder.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="date-width" appearance="outline">
        <mat-label>Data</mat-label>
        <input matInput [matDatepicker]="picker" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.date">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

      <div style='margin: 10px;'>
        <mat-checkbox color='primary' [formControl]="entityForm.controls.approved">
          Aprovado
        </mat-checkbox>
      </div>

    </div>

  </form>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
    <button *ngIf="!isEdit" mat-raised-button
      (click)="matDialogRef.close([ 'add', entityForm, selectedFolder, selectedDocFile ])"
      [disabled]="entityForm.invalid">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
    <button *ngIf="isEdit" mat-raised-button
      (click)="matDialogRef.close([ 'edit', entityForm, selectedFolder, selectedDocFile ])"
      [disabled]="entityForm.invalid">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
  </div>

</div>